__turbopack_context__.v({
  "action": "suggestionBalloon-module-scss-module__L3flsW__action",
  "balloon": "suggestionBalloon-module-scss-module__L3flsW__balloon",
  "body": "suggestionBalloon-module-scss-module__L3flsW__body",
  "dismiss": "suggestionBalloon-module-scss-module__L3flsW__dismiss",
  "icon": "suggestionBalloon-module-scss-module__L3flsW__icon",
  "message": "suggestionBalloon-module-scss-module__L3flsW__message",
  "suggestion-fade-in": "suggestionBalloon-module-scss-module__L3flsW__suggestion-fade-in",
  "suggestion-in": "suggestionBalloon-module-scss-module__L3flsW__suggestion-in",
  "title": "suggestionBalloon-module-scss-module__L3flsW__title",
});
